import { UserAccessLevelType } from "~/common/services/user/user.types";

export interface ClientContextParts {
  branchName?: string | null;
  locationName?: string | null;
  clientType?: string | null;
  /** Branch segment is included only when true (persona-gated). */
  showBranch: boolean;
  /** Separator between segments. Defaults to "-" (renders as " - "). */
  separator?: string;
}

/**
 * Persona access levels for which the Branch segment is shown in the
 * See Possible search results and client-header breadcrumb. Single source of
 * truth — do not inline these literals elsewhere (US 24656).
 */
export const BRANCH_VISIBLE_ACCESS_LEVELS: UserAccessLevelType[] = [
  "CentralTeamMember",
  "RegionalLeader",
];

export function shouldShowBranchForPersona(
  accessLevel?: UserAccessLevelType | string | null
): boolean {
  return BRANCH_VISIBLE_ACCESS_LEVELS.includes(
    accessLevel as UserAccessLevelType
  );
}

/**
 * Joins the non-empty Branch / Location / ClientType segments into a
 * persona-aware context string, e.g. "Coastal Plains - Wilmington - Personal"
 * (branch-visible) or "Wilmington - Personal" (other personas). The proc
 * "multiple" sentinel is a normal non-empty string and is rendered verbatim.
 */
export function formatClientContext({
  branchName,
  locationName,
  clientType,
  showBranch,
  separator = "-",
}: ClientContextParts): string {
  return [showBranch ? branchName : undefined, locationName, clientType]
    .map((segment) => segment?.trim())
    .filter((segment): segment is string => !!segment)
    .join(` ${separator} `);
}
